module.exports = __webpack_public_path__ + "img/whatsapp-nav.2fc4e821c45be1030d3d79826dffd69a.svg";